import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";

class AttachedDocumentRepository {
  async create(data: any): Promise<Message<any>> {
    const response = await httpClient.post(`/attached-documents`, { data });
    return response.data;
  }

  async getByObjectId(objectType: string, objectId: string): Promise<Message<any[]>> {
    const response = await httpClient.get(`/attached-documents/${objectType}/${objectId}`);
    return response.data;
  }

  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/attached-documents/${id}`);
    return response.data;
  }
}

const attachedDocumentRepository = new AttachedDocumentRepository();
export default attachedDocumentRepository;
